import { MutationTree } from 'vuex';
import { AdmpNewsState } from './types';
import Vue from 'vue';
import admpNews, { AdmpNews, Value } from '@/shared/model/admpNews';

export const mutations: MutationTree<AdmpNewsState> = {
  setAdmpNews(state, payload: Value) {
    const items = payload?.value ?? (Array.isArray(payload) ? (payload as any) : []);
    state.AdmpNews.items = items.map((x: any) => admpNews.parse(x));
    state.AdmpNews.total = payload?.['@odata.count'] || items.length;
    state.AdmpNews.isLoading = false;
  },
  setAdmpNewsTotal(state, payload: number) {
    state.AdmpNews.total = payload;
  },
  setAdmpNewsIsLoading(state, payload: boolean) {
    state.AdmpNews.isLoading = payload;
  },
  setAdmpNewsSearchData(state, payload: any) {
    state.admpNewsSearchData = payload;
  },

  setNewsInfo(state, payload: any) {
    let news = state.AdmpNews.items.find((x) => x.id == payload.zr_news_id);
    if (news && news.news_read_info.length == 0) {
      news.news_read_info.push(payload);
    } else if (news && news.news_read_info.length > 0) {
      let news_info = news.news_read_info.findIndex((x) => x.id == payload.id);
      if (news_info > -1) {
        news.news_read_info.splice(news_info, 1, payload);
      }
    }

    let newsDashboad = state.admpNewsDashboad.find((x) => x.id == payload.zr_news_id);
    if (newsDashboad && newsDashboad.news_read_info.length == 0) {
      newsDashboad.news_read_info.push(payload);
    } else if (newsDashboad && newsDashboad.news_read_info.length > 0) {
      let news_info = newsDashboad.news_read_info.findIndex((x: any) => x.id == payload.id);
      if (news_info > -1) {
        newsDashboad.news_read_info.splice(news_info, 1, payload);
      }
    }
  },

  setAdmpNewsImagesArr(state, data: any) {
    if (!data || !data.id) return;

    if (!data.imageLink) {
      const updated = { ...state.admpNewsImages };
      delete updated[data.id];
      state.admpNewsImages = updated;
    } else {
      state.admpNewsImages = {
        ...state.admpNewsImages,
        [data.id]: data.imageLink,
      };
    }
  },
  setUnreadNews(state, payload: number) {
    state.unreadNews = payload;
  },
  setAdmpNewsContactType(state, payload: string) {
    state.admpNewsContactType = payload;
  },
  setChangeUnreadNews(state, payload: number) {
    if (state.unreadNews == 0 && payload == -1) {
      return;
    }
    state.unreadNews += payload;
  },
  setAdmpNewsDashboard(state, payload: any) {
    state.admpNewsDashboad = payload;
  },
  setAdmpNewsDashboardIsLoading(state, payload: boolean) {
    state.isAdmpNewsDashboardIsLoading = payload;
  },
};
